import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import Text from "components/atoms/Text";
import Icon from "components/atoms/Icon";
import { COLOR_SYSTEM } from "components/design/design-system";
import { RootState } from "store";

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
`;

const StatCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  background: ${COLOR_SYSTEM.get("Gray")?.[0]};
  border-radius: 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[200]};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const StatTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StatIconWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[200]};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const formatNumber = (n: number | null | undefined): string => {
  if (n === null || n === undefined) return "-";
  return n.toLocaleString("ko-KR");
};

const DashboardStatsCards: React.FC = () => {
  const patientCount = useSelector(
    (state: RootState) => state.data.patientList?.length ?? 0,
  );
  const aiReviewCount = useSelector((state: RootState) => state.data.aiReviewCount);

  return (
    <CardGrid>
      <StatCard>
        <StatTextGroup>
          <Text textType="Body1" color={COLOR_SYSTEM.get("Gray")?.[500]}>
            전체 환자
          </Text>
          <Text textType="LargeTitle2" color={COLOR_SYSTEM.get("Gray")?.[800]}>
            {formatNumber(patientCount)}명
          </Text>
        </StatTextGroup>
        <StatIconWrapper>
          <Icon name="User" size={28} color={COLOR_SYSTEM.get("Gray")?.[800]} />
        </StatIconWrapper>
      </StatCard>

      <StatCard>
        <StatTextGroup>
          <Text textType="Body1" color={COLOR_SYSTEM.get("Gray")?.[500]}>
            전체 보고서
          </Text>
          <Text textType="LargeTitle2" color={COLOR_SYSTEM.get("Gray")?.[800]}>
            {formatNumber(aiReviewCount)}건
          </Text>
        </StatTextGroup>
        <StatIconWrapper>
          <Icon name="Document" size={28} color={COLOR_SYSTEM.get("Gray")?.[800]} />
        </StatIconWrapper>
      </StatCard>
    </CardGrid>
  );
};

export default DashboardStatsCards;
